import React from 'react'
import { LOCALE } from '../../../constants/activity-constants';

const arg = LOCALE === "es-AR"

const Text1ByCountry = () => {
  let text;
  if(arg){
    text = <>
      <b className="f-pink">Iniciá sesión o registrate,</b> y empezá a
      ingresar las claves de cualquier producto Nosotras para activar el
      universo. <br />
    </>
  }else{
    text = <>
      <b className="f-pink">Inicia sesión o regístrate,</b> y empieza a
      ingresar las claves de cualquier producto Nosotras para activar el
      universo. <br />
    </>
  }

  return (
    text
  )
}
const Text2ByCountry = () => {
  let text;
  if(arg){
    text = <>
      <b>Elegí el planeta que más te guste </b>y da clic al botón jugar
      para iniciar. <b className="f-pink">Recordá</b> que podrás jugar
      en los 3 planetas al mismo tiempo y las veces que querás.
    </>
  }else{
    text = <>
      <b>Elige el planeta que más te guste </b>y da clic al botón jugar
      para iniciar. <b className="f-pink">Recuerda</b> que podrás jugar
      en los 3 planetas al mismo tiempo y las veces que quieras.
    </>
  }

  return (
    text
  )
}
const Text3ByCountry = () => {
  let text;
  if(arg){
    text = <>
      <b className="f-pink">¡Te quedaste sin vidas! </b>Pero tranquila,
      recordá que con una <b>clave especial </b>, o con alguna clave de
      cualquier producto Nosotras, podrás volver a{' '}
      <b>activar el universo.</b>
    </>
  }else{
    text = <>
      <b className="f-pink">¡Te quedaste sin vidas! </b>Pero tranquila,
      recuerda que con una <b>clave especial </b>, o con alguna clave de
      cualquier producto Nosotras, podrás volver a{' '}
      <b>activar el universo.</b>
    </>
  }

  return (
    text
  )
}

export const text_replica_content_play1 = Text1ByCountry()
export const text_replica_content_play2 = Text2ByCountry()
export const text_replica_content_play3 = Text3ByCountry()
